import React, {
  useEffect,
  useState,
} from "react";

import { Link } from "gatsby";

import "./SearchBar.scss";

import {
  getInitialLocale,
  type SupportedLocale,
} from "../../utils/i18n";

import {
  GatsbyImage,
  type IGatsbyImageData,
} from "gatsby-plugin-image";

interface SearchItem {

  title: string;

  slug: string;

  locale: SupportedLocale;

  type: string;

  shortDescription?: string;

  description?: string;

  tags?: string[];

  coverImage?: IGatsbyImageData | null

}





export default function SearchBar() {


  const [locale, setLocale] =
    useState<SupportedLocale>("en");



  const [query, setQuery] =
    useState("");



  const [items, setItems] =
    useState<SearchItem[]>([]);



  const [results, setResults] =
    useState<SearchItem[]>([]);



  const [isMobile, setIsMobile] =
    useState<boolean | null>(null);





  useEffect(() => {


    setLocale(
      getInitialLocale()
    );



    const checkScreen = () => {

      setIsMobile(
        window.innerWidth <= 600
      );

    };



    checkScreen();



    window.addEventListener(
      "resize",
      checkScreen
    );




    fetch("/search-index.json")

      .then(
        response =>
          response.json()
      )

      .then(
        data => {


          if (
            Array.isArray(data)
          ) {


            setItems(data);


          }


        }

      );




    return () => {


      window.removeEventListener(
        "resize",
        checkScreen
      );


    };


  }, []);









  useEffect(() => {


    if (
      query.trim().length < 2
    ) {


      setResults([]);

      return;


    }






    const searchTerm =
      query.toLowerCase();





    const filtered =


      items


      .filter(
        item =>
          item.locale === locale
      )


      .filter(
        item => {


          const searchableText =

            (

              item.title +

              " " +

              item.shortDescription +

              " " +

              item.description +

              " " +

              item.type +

              " " +

              item.tags?.join(" ")

            )

            .toLowerCase();




          return searchableText.includes(
            searchTerm
          );


        }

      )


      .slice(
        0,
        6
      );





    setResults(filtered);




  }, [

    query,

    items,

    locale

  ]);








const placeholder =
  isMobile === true
    ? "Search..."
    : "Search Sorrento...";








  return (


    <div className="search">



      <span className="searchIcon">

        🔎︎

      </span>





      <input

        id="search"
        
        name="search"

        type="text"


        value={query}


        placeholder={placeholder}


        aria-label={placeholder}


        onChange={
          event =>
            setQuery(
              event.target.value
            )
        }


      />







      {
        results.length > 0 && (


          <div className="searchResults">


            {
              results.map(
                item => (



                  <Link


                    key={
                      `${item.locale}-${item.slug}`
                    }


                    to={
                      `/${item.locale}/${item.slug}/`
                    }


                    className="searchResult"


                    onClick={
                      () =>
                        setQuery("")
                    }


                  >




                    {
                      item.coverImage && (


                        <GatsbyImage
                        image={item.coverImage}
                        alt={item.title}
                      />


                      )

                    }






                    <div className="searchResultContent">



                      <strong>

                        {item.title}

                      </strong>





                      {
                        item.shortDescription && (


                          <p>

                            {
                              item.shortDescription
                            }

                          </p>


                        )

                      }







                      <span>

                        {
                          item.type
                        }

                      </span>




                    </div>



                  </Link>



                )

              )

            }



          </div>


        )

      }



    </div>


  );


}